import gql from "graphql-tag";

export function productVersionsCreateMutation(input) {
    return {
        mutation: gql`
            mutation($input: ProductVersionInput!) {
                result: createProductVersion(input: $input) { id }
            }
        `,
        variables: { input },
    };
}

export function productVersionsUpdateMutation(input, id) {
    return {
        mutation: gql`
            mutation($id: ID!, $input: ProductVersionInput!) {
                result: updateProductVersion(id: $id, input: $input) { id }
            }
        `,
        variables: { input, id },
    };
}
